import { z } from 'zod';
import { POSITION_STATUS_SCHEMA, ProjectNumberSchema, ProjectPositionNumberSchema } from './shared.ts';
import { CustomerInfoSchema } from './customer-info.ts';
import { PositionGroupSchema } from './position-group.ts';

export const PositionSchema = z.strictObject({
    id: z.string().uuid(),
    projectNumber: ProjectNumberSchema,
    salesforceOpportunityId: z.string(),
    positionNumber: ProjectPositionNumberSchema,
    marketCode: z.string(),
    status: POSITION_STATUS_SCHEMA,
    validFrom: z.coerce.date().nullable(),
    note: z.string().optional().nullable(),
    active: z.boolean(),
    validTo: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    orderCount: z.number(),
    customerInfo: CustomerInfoSchema,
    positionGroup: PositionGroupSchema,
});
